/**
 * A function that returns a Promise
 * @typedef {(<T = any>() => Promise<T>)} Task
 */

/**
 *
 * @param {Array<Task>} tasks
 * @param {number} limit
 * @param taskCallback
 */
export async function* batchTasks(
	tasks: (() => Promise<any>)[],
	limit: number,
	taskCallback = (r: any) => r,
): AsyncGenerator<any[], void, unknown> {
	const startTask = (taskIndex: number): Promise<{ taskIndex: number; r: any }> =>
		tasks[taskIndex]().then((r) => {
			return {
				r: taskCallback && taskCallback(r),
				taskIndex,
			};
		});

	const currentTasks: Map<number, Promise<{ taskIndex: number; r: any }>> = new Map();

	let nextTaskIndex = 0;
	while (currentTasks.size < limit && nextTaskIndex < tasks.length) {
		currentTasks.set(nextTaskIndex, startTask(nextTaskIndex));
		nextTaskIndex++;
	}

	while (currentTasks.size > 0) {
		const { taskIndex, r } = await Promise.race(Array.from(currentTasks.values()));

		// Start the next task if there are more tasks to process
		if (nextTaskIndex <= tasks.length - 1) {
			currentTasks.set(nextTaskIndex, startTask(nextTaskIndex));
			nextTaskIndex++;
		}

		currentTasks.delete(taskIndex);
		yield [r];
	}
}
